import { render, staticRenderFns } from "./MyTax.vue?vue&type=template&id=ece41756&"
import script from "./MyTax.vue?vue&type=script&lang=js&"
export * from "./MyTax.vue?vue&type=script&lang=js&"
import style0 from "./MyTax.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports